<app-header ></app-header>
<main>
  <div class="container">
    <div class="row  my-3">
      <div class="col-lg-3 order-lg-1 order-2">
        <div class="categories d-lg-block d-none">
          <div class="border-0 text-center categorie-list" >
            <a  routerLink="home/{{category.id}}" routerLinkActive="selected" class="dropdown-item px-4 mb-1 py-2  text-white text-uppercase d-inline-block" *ngFor="let category of categories;let i=index" > 
                <img src="{{category.image}}" alt="{{category.name_en}}" class="img-fluid">{{category.name_en}}
            </a>
        </div>
        </div>
        <div class="row" >
          <div class="col-lg-12 col-sm-6 col-12" routerLink="offers/mosque">
              <!-- Hot deals -->
              <section class="hot-deals bg-main-color p-3 mb-4">
                  <h6 class="text-uppercase text-white pb-3 border-bottom">
                      hot deal for mosque
      
                  </h6>
                  <div class="hot-deal-list ">
                      <div class="hot-deal ">
                          <div class="hot-deal-img">
                              <img src="assets/imgs/icons/bleding.png" alt="" class="img-fluid img-fit">
                          </div>
                          <div class="hot-deal-info text-center">
                              <h6 class="text-uppercase text-white text-truncate">mosque offer</h6>
                              
                          </div>
                         
                      </div>
                  </div>
              </section>
              <!-- ./Hot deals -->
      
          </div>
          <div class="col-lg-12 col-sm-6 col-12" routerLink="offers/company">
            <!-- Hot deals -->
            <section class="hot-deals bg-main-color p-3 mb-4">
                <h6 class="text-uppercase text-white pb-3 border-bottom">
                    hot deal for company
    
                </h6>
                <div class="hot-deal-list ">
                    <div class="hot-deal ">
                        <div class="hot-deal-img">
                            <img src="assets/imgs/icons/factory.png" alt="" class="img-fluid img-fit">
                        </div>
                        <div class="hot-deal-info text-center">
                            <h6 class="text-uppercase text-white text-truncate">company offer</h6>
                            
                        </div>
                       
                    </div>
                </div>
            </section>
            <!-- ./Hot deals -->
    
        </div>
      
      </div>
        <app-advertise></app-advertise>
      </div>
      <div class="col-lg-9 order-lg-2 order-1 mb-4">
        <router-outlet></router-outlet>

      </div>
    </div>
  </div>

</main>
<app-footer></app-footer>